import React, { useState, useEffect } from "react";
import logo from "../assets/pathway_rect.webp";
import { SiFacebook } from "react-icons/si";

export default function Nav() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    document.body.style.overflow = !mobileMenuOpen ? "hidden" : "unset";
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    document.body.style.overflow = "unset";
  };

  return (
    <>
      <nav
        className={`fixed top-0 z-50 w-full font-nunito transition-all duration-500 ${
          scrolled
            ? "bg-white/95 shadow-lg shadow-blue-100/50 backdrop-blur-md"
            : "bg-white shadow-md"
        }`}
      >
        <div className="container relative mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <a
              href="/"
              className="group relative z-10 transition-transform duration-300 hover:scale-105"
            >
              <img
                src={logo}
                alt="Pathway Resource Center"
                className="h-14 transition-all duration-300 group-hover:drop-shadow-md"
                loading="eager"
              />
            </a>

            {/* Desktop Navigation */}
            <div className="hidden items-center gap-8 lg:flex">
              {/* Services Dropdown */}
              <div className="group relative">
                <button className="flex items-center gap-1 py-2 text-[15px] font-medium text-gray-700 transition-colors duration-200 hover:text-[#457B9D]">
                  Services
                  <svg
                    className="h-4 w-4 transition-transform duration-200 group-hover:rotate-180"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>
                <div className="pointer-events-none absolute left-0 top-full pt-2 opacity-0 transition-all duration-300 group-hover:pointer-events-auto group-hover:opacity-100">
                  <div className="min-w-[240px] overflow-hidden rounded-2xl bg-white shadow-xl shadow-blue-100/50 ring-1 ring-gray-100">
                    <div className="p-2">
                      <a
                        href="/pregnancy-services"
                        className="group/item flex items-center gap-3 rounded-xl px-4 py-3 text-sm text-gray-700 transition-all duration-200 hover:bg-gradient-to-r hover:from-[#457B9D]/10 hover:to-[#E8998D]/10 hover:pl-5"
                      >
                        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#457B9D]/10 text-[#457B9D] transition-transform duration-200 group-hover/item:scale-110">
                          <svg
                            className="h-4 w-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                            />
                          </svg>
                        </span>
                        Pregnancy Services
                      </a>
                      <a
                        href="/emergency-resources"
                        className="group/item flex items-center gap-3 rounded-xl px-4 py-3 text-sm text-gray-700 transition-all duration-200 hover:bg-gradient-to-r hover:from-[#457B9D]/10 hover:to-[#E8998D]/10 hover:pl-5"
                      >
                        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#E8998D]/20 text-[#E8998D] transition-transform duration-200 group-hover/item:scale-110">
                          <svg
                            className="h-4 w-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M13 10V3L4 14h7v7l9-11h-7z"
                            />
                          </svg>
                        </span>
                        Emergency Resources
                      </a>
                      <a
                        href="/pill-reversal"
                        className="group/item flex items-center gap-3 rounded-xl px-4 py-3 text-sm text-gray-700 transition-all duration-200 hover:bg-gradient-to-r hover:from-[#EC4899]/10 hover:to-[#F472B6]/10 hover:pl-5"
                      >
                        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#EC4899]/20 text-[#EC4899] transition-transform duration-200 group-hover/item:scale-110">
                          <svg
                            className="h-4 w-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                          </svg>
                        </span>
                        Pill Reversal
                      </a>
                      <a
                        href="/after-abortion-care"
                        className="group/item flex items-center gap-3 rounded-xl px-4 py-3 text-sm text-gray-700 transition-all duration-200 hover:bg-gradient-to-r hover:from-[#457B9D]/10 hover:to-[#E8998D]/10 hover:pl-5"
                      >
                        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#457B9D]/10 text-[#457B9D] transition-transform duration-200 group-hover/item:scale-110">
                          <svg
                            className="h-4 w-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                            />
                          </svg>
                        </span>
                        After Abortion Care
                      </a>
                      <a
                        href="/curriculum"
                        className="group/item flex items-center gap-3 rounded-xl px-4 py-3 text-sm text-gray-700 transition-all duration-200 hover:bg-gradient-to-r hover:from-[#457B9D]/10 hover:to-[#E8998D]/10 hover:pl-5"
                      >
                        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#E8998D]/20 text-[#E8998D] transition-transform duration-200 group-hover/item:scale-110">
                          <svg
                            className="h-4 w-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                            />
                          </svg>
                        </span>
                        Youth Curriculum
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <a
                href="/about"
                className="py-2 text-[15px] font-medium text-gray-700 transition-colors duration-200 hover:text-[#457B9D]"
              >
                About
              </a>

              {/* Contact Dropdown */}
              <div className="group relative">
                <button className="flex items-center gap-1 py-2 text-[15px] font-medium text-gray-700 transition-colors duration-200 hover:text-[#457B9D]">
                  Contact
                  <svg
                    className="h-4 w-4 transition-transform duration-200 group-hover:rotate-180"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>
                <div className="pointer-events-none absolute left-0 top-full pt-2 opacity-0 transition-all duration-300 group-hover:pointer-events-auto group-hover:opacity-100">
                  <div className="min-w-[200px] overflow-hidden rounded-2xl bg-white shadow-xl shadow-blue-100/50 ring-1 ring-gray-100">
                    <div className="p-2">
                      <a
                        href="/contact"
                        className="block rounded-xl px-4 py-3 text-sm text-gray-700 transition-all duration-200 hover:bg-gradient-to-r hover:from-[#457B9D]/10 hover:to-[#E8998D]/10 hover:pl-5"
                      >
                        Get In Touch
                      </a>
                      <a
                        href="/newsletter"
                        className="block rounded-xl px-4 py-3 text-sm text-gray-700 transition-all duration-200 hover:bg-gradient-to-r hover:from-[#457B9D]/10 hover:to-[#E8998D]/10 hover:pl-5"
                      >
                        Newsletter
                      </a>
                      <a
                        href="/contact"
                        className="block rounded-xl px-4 py-3 text-sm text-gray-700 transition-all duration-200 hover:bg-gradient-to-r hover:from-[#457B9D]/10 hover:to-[#E8998D]/10 hover:pl-5"
                      >
                        Volunteer
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {/* CTA Buttons */}
              <a
                href="/pill-reversal"
                className="group relative overflow-hidden rounded-full bg-gradient-to-r from-[#EC4899] to-[#F472B6] px-6 py-2.5 text-sm font-semibold text-white shadow-md shadow-pink-400/30 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-pink-400/40"
              >
                <span className="relative z-10">Pill Reversal</span>
                <div className="absolute inset-0 -z-0 bg-gradient-to-r from-[#F472B6] to-[#EC4899] opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
              </a>

              <a
                href="https://engage.suran.com/pathwayresourcecenter/s/give/gift/80c96cabadbd4f9"
                target="_blank"
                rel="noreferrer"
                className="group relative overflow-hidden rounded-full bg-gradient-to-r from-[#457B9D] to-[#5891B5] px-6 py-2.5 text-sm font-semibold text-white shadow-md shadow-[#457B9D]/30 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-[#457B9D]/40"
              >
                <span className="relative z-10">Donate</span>
                <div className="absolute inset-0 -z-0 bg-gradient-to-r from-[#5891B5] to-[#457B9D] opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
              </a>

              <a
                href="https://www.facebook.com/PathwayTXK/"
                target="_blank"
                rel="noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-[#457B9D]/10 to-[#E8998D]/10 text-[#457B9D] transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-[#457B9D]/20"
              >
                <SiFacebook className="text-xl" />
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={toggleMobileMenu}
              className="group relative z-10 flex h-10 w-10 flex-col items-center justify-center rounded-full transition-all duration-300 hover:bg-gray-100 lg:hidden"
              aria-label="Toggle mobile menu"
            >
              <span
                className={`mb-1.5 h-0.5 w-6 bg-gray-700 transition-all duration-300 ${
                  mobileMenuOpen ? "translate-y-2 rotate-45" : ""
                }`}
              />
              <span
                className={`mb-1.5 h-0.5 w-6 bg-gray-700 transition-all duration-300 ${
                  mobileMenuOpen ? "opacity-0" : ""
                }`}
              />
              <span
                className={`h-0.5 w-6 bg-gray-700 transition-all duration-300 ${
                  mobileMenuOpen ? "-translate-y-2 -rotate-45" : ""
                }`}
              />
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div
        className={`fixed inset-0 z-40 bg-gray-900/50 backdrop-blur-sm transition-all duration-500 lg:hidden ${
          mobileMenuOpen
            ? "pointer-events-auto opacity-100"
            : "pointer-events-none opacity-0"
        }`}
        onClick={closeMobileMenu}
      />

      {/* Mobile Menu Panel */}
      <div
        className={`fixed right-0 top-0 z-40 h-full w-full max-w-sm transform bg-white shadow-2xl transition-transform duration-500 ease-out lg:hidden ${
          mobileMenuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex h-full flex-col overflow-y-auto">
          {/* Mobile Menu Header */}
          <div className="border-b border-gray-100 p-6 pt-20">
            <h2 className="text-2xl font-bold text-gray-800"> </h2>
          </div>

          {/* Mobile Menu Content */}
          <div className="flex-1 space-y-1 p-4">
            {/* Pill Reversal Button - Featured */}
            <a
              href="/pill-reversal"
              onClick={closeMobileMenu}
              className="mb-4 block rounded-2xl bg-gradient-to-r from-[#EC4899] to-[#F472B6] px-6 py-4 text-center text-base font-semibold text-white shadow-lg shadow-pink-400/30"
            >
              Pill Reversal
            </a>

            {/* Donate Button - Featured */}
            <a
              href="https://engage.suran.com/pathwayresourcecenter/s/give/gift/80c96cabadbd4f9"
              target="_blank"
              rel="noreferrer"
              onClick={closeMobileMenu}
              className="mb-6 block rounded-2xl bg-gradient-to-r from-[#457B9D] to-[#5891B5] px-6 py-4 text-center text-base font-semibold text-white shadow-lg shadow-[#457B9D]/30"
            >
              Donate
            </a>

            {/* Services Section */}
            <div className="space-y-1">
              <h3 className="px-4 py-3 text-xs font-bold uppercase tracking-wider text-gray-500">
                Services
              </h3>
              <a
                href="/pregnancy-services"
                onClick={closeMobileMenu}
                className="block rounded-xl px-4 py-3 text-gray-700 transition-colors duration-200 hover:bg-gradient-to-r hover:from-[#457B9D]/10 hover:to-[#E8998D]/10"
              >
                Pregnancy Services
              </a>
              <a
                href="/emergency-resources"
                onClick={closeMobileMenu}
                className="block rounded-xl px-4 py-3 text-gray-700 transition-colors duration-200 hover:bg-gradient-to-r hover:from-[#457B9D]/10 hover:to-[#E8998D]/10"
              >
                Emergency Resources
              </a>
              <a
                href="/pill-reversal"
                onClick={closeMobileMenu}
                className="block rounded-xl px-4 py-3 font-medium text-[#EC4899] transition-colors duration-200 hover:bg-gradient-to-r hover:from-[#EC4899]/10 hover:to-[#F472B6]/10"
              >
                Pill Reversal
              </a>
              <a
                href="/after-abortion-care"
                onClick={closeMobileMenu}
                className="block rounded-xl px-4 py-3 text-gray-700 transition-colors duration-200 hover:bg-gradient-to-r hover:from-[#457B9D]/10 hover:to-[#E8998D]/10"
              >
                After Abortion Care
              </a>
              <a
                href="/curriculum"
                onClick={closeMobileMenu}
                className="block rounded-xl px-4 py-3 text-gray-700 transition-colors duration-200 hover:bg-gradient-to-r hover:from-[#457B9D]/10 hover:to-[#E8998D]/10"
              >
                Youth Curriculum
              </a>
            </div>

            {/* About Section */}
            <div className="space-y-1 pt-4">
              <h3 className="px-4 py-3 text-xs font-bold uppercase tracking-wider text-gray-500">
                About
              </h3>
              <a
                href="/about"
                onClick={closeMobileMenu}
                className="block rounded-xl px-4 py-3 text-gray-700 transition-colors duration-200 hover:bg-gradient-to-r hover:from-[#457B9D]/10 hover:to-[#E8998D]/10"
              >
                Who We Are
              </a>
            </div>

            {/* Contact Section */}
            <div className="space-y-1 pt-4">
              <h3 className="px-4 py-3 text-xs font-bold uppercase tracking-wider text-gray-500">
                Contact
              </h3>
              <a
                href="/contact"
                onClick={closeMobileMenu}
                className="block rounded-xl px-4 py-3 text-gray-700 transition-colors duration-200 hover:bg-gradient-to-r hover:from-[#457B9D]/10 hover:to-[#E8998D]/10"
              >
                Get In Touch
              </a>
              <a
                href="/newsletter"
                onClick={closeMobileMenu}
                className="block rounded-xl px-4 py-3 text-gray-700 transition-colors duration-200 hover:bg-gradient-to-r hover:from-[#457B9D]/10 hover:to-[#E8998D]/10"
              >
                Newsletter
              </a>
              <a
                href="/contact"
                onClick={closeMobileMenu}
                className="block rounded-xl px-4 py-3 text-gray-700 transition-colors duration-200 hover:bg-gradient-to-r hover:from-[#457B9D]/10 hover:to-[#E8998D]/10"
              >
                Volunteer
              </a>
            </div>
          </div>

          {/* Mobile Menu Footer */}
          <div className="border-t border-gray-100 p-6">
            <a
              href="https://www.facebook.com/PathwayTXK/"
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-center gap-3 rounded-2xl bg-gradient-to-br from-[#457B9D]/10 to-[#E8998D]/10 px-6 py-4 text-[#457B9D] transition-all duration-300 hover:shadow-md"
            >
              <SiFacebook className="text-2xl" />
              <span className="font-semibold">Follow us on Facebook</span>
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
